import React from "react";
import {UserContext} from '../providers';

function useUser() {
    return React.useContext(UserContext);
}

export {useUser}
